import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    Image, Input, Label, TeachingPopover, TeachingPopoverBody, TeachingPopoverSurface, TeachingPopoverTrigger
} from "@fluentui/react-components";
import {addParticipant} from "../handlers/registrationhandler";
import {useId, useState} from "react";
import ParticipantCbCard from "./ParticipantCbCard";
import ChangeParticipantDialog from "./ChangeParticipantDialog";
import {
    Add12Filled,
    ArrowClockwise16Regular,
    Info16Filled,
    Info16Regular,
    Info20Regular,
    QuestionCircleColor
} from "@fluentui/react-icons";
import {
    addParticipantToDatabaseByRowID,
    fetchParticipantsByClubIDFromDatabase,
    getAmountOfParticipantsInBoat
} from "../handlers/databasehandler";
import SubText from "./SubText";
import Participant from "../models/Participant";
import HelpImageBoatId from "../assets/HelpImageBoatID.png";
import {boatIdLanguages} from "../models/Manual";


function AddParticipantButton({text, eventId, participants, clubId, distanceId, maxParticipantsInBoat, onAdded, onUpdateParticipants}) {
    const sortedParticipants = [...participants].sort((a, b) =>
        a.first_name.localeCompare(b.first_name)
    );

    const [selectedIds, setSelectedIds] = useState([]);
    const [localParticipants, setParticipants] = useState(sortedParticipants);
    const [searchedParticipants, setSearchedParticipants] = useState(sortedParticipants);
    const [amountOfParticipantsAvailableInBoat, setAmountOfParticipantsAvailableInBoat] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [teachingLanguage, setTeachingLanguage] = useState("nl");
    const boatId = useId();
    const searchId = useId();

    const searchParticipants = (searchValue) => {
        setSearchValue(searchValue);

        if (searchValue === "") {
            setSearchedParticipants(localParticipants);
        }

        setSearchedParticipants(localParticipants.filter(p => (p instanceof Participant) && p.fullName.toLowerCase().includes(searchValue.toLowerCase())));
    }

    const handleCheckboxChange = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
        );
    };

    const handleAddParticipants = async () => {
        const boatIdValue = getBoatIdValue();

        for (const id of selectedIds) {
            if (boatIdValue) {
                await addParticipantToDatabaseByRowID(boatIdValue, id, distanceId);
                continue;
            }

            await addParticipant(eventId, distanceId, id);
        }
        if (onAdded) onAdded();
    };

    const getParticipants = async () => {
        if (!clubId) return;

        const data = await fetchParticipantsByClubIDFromDatabase(clubId);
        if (data == null) {
            return;
        }

        const sortedParticipants = [...data].sort((a, b) =>
            a.first_name.localeCompare(b.first_name)
        );

        setParticipants(sortedParticipants);
        setSearchValue("");
        setSearchedParticipants(sortedParticipants);

        if (onUpdateParticipants) onUpdateParticipants(data);
    }

    const checkAmountOfParticipantsAvailableInBoat = async () => {
        const boatIdValue = getBoatIdValue();
        if (boatIdValue == null || boatIdValue === "") {
            setAmountOfParticipantsAvailableInBoat(null);
            return;
        }

        const amountOfParticipantsInBoat = await getAmountOfParticipantsInBoat(boatIdValue, distanceId);

        if (amountOfParticipantsInBoat == null) {
            setAmountOfParticipantsAvailableInBoat(-1);
            return;
        }

        setAmountOfParticipantsAvailableInBoat(maxParticipantsInBoat - amountOfParticipantsInBoat);
    }

    const getBoatIdValue = () => {
        return document.getElementById(boatId).value;
    }

    return (
        <Dialog>
            <DialogTrigger>
                <div style={{display: "flex"}}>
                    <Button as={"a"} className={`button`} appearance={"primary"}>
                        {text}
                    </Button>
                </div>
            </DialogTrigger>
            <DialogSurface className={`dialog`}>
                <DialogContent style={{display: "flex", flexDirection: "column", gap: "10px", maxWidth: "600px", marginBottom: "10px"}}>
                    <DialogTitle>Deelnemers toevoegen</DialogTitle>
                    <div className={`flex flex-column flex-gap-small`}>
                        <Label htmlFor={searchId}>
                            Zoek deelnemers:
                        </Label>
                        <Input id={searchId} className={`input`} value={searchValue} onChange={(event, data) => searchParticipants(data.value)} type={`text`}/>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px", maxHeight: "300px", overflowY: "auto",}}>
                        <div>
                            {searchedParticipants.map((participant, index) => (
                                <div style={{ padding: 2}} key={index}>
                                    <ParticipantCbCard
                                        participant={participant}
                                        checked={selectedIds.includes(participant.id)}
                                        onChange={() => handleCheckboxChange(participant.id)}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className={`flex flex-gap-small`} style={{ padding: 2 }}>
                            <ChangeParticipantDialog buttonText={<><Add12Filled/> Nieuwe Deelnemer Toevoegen</>} fetchedParticipant={null} clubId={clubId} onAdded={() => getParticipants()} verifiedStatus={"VERIFIED"}/>
                            <Button as={`a`} className={`button`} appearance={`secondary`} onClick={() => getParticipants(clubId)}>
                                <ArrowClockwise16Regular/> Opnieuw laden
                            </Button>
                        </div>
                    </div>
                    <div className={`flex flex-column flex-gap-small`} style={{ maxHeight: "400px" }}>
                        <SubText text={"Toevoegen aan een andere boot?"}/>
                        <div className={`flex flex-gap-small flex-align-center`}>
                            <Label htmlFor={boatId}>
                                Boot ID
                            </Label>
                            <TeachingPopover>
                                <TeachingPopoverTrigger>
                                    <Button as={`a`} className={`button`} appearance={`subtle`} icon={<QuestionCircleColor/>}/>
                                </TeachingPopoverTrigger>
                                <TeachingPopoverSurface className={`dialog`}>
                                    <TeachingPopoverBody
                                        media={<Image alt="Help Image boat ID" fit="cover" src={HelpImageBoatId} />}
                                    >
                                        <div className={`flex flex-gap-medium`}>
                                            <Button
                                                as={`a`}
                                                appearance={teachingLanguage === "nl" ? "primary" : "secondary"}
                                                size="small"
                                                onClick={() => setTeachingLanguage("nl")}
                                            >
                                                🇳🇱 Nederlands
                                            </Button>
                                            <Button
                                                as={`a`}
                                                appearance={teachingLanguage === "en" ? "primary" : "secondary"}
                                                size="small"
                                                onClick={() => setTeachingLanguage("en")}
                                            >
                                                🇬🇧 English
                                            </Button>
                                        </div>
                                        <p className={`flex-wrap`} style={{maxWidth: 400}}>
                                            {boatIdLanguages[teachingLanguage]}
                                        </p>
                                    </TeachingPopoverBody>
                                </TeachingPopoverSurface>
                            </TeachingPopover>
                        </div>
                        <Input id={boatId} onChange={async () => checkAmountOfParticipantsAvailableInBoat() }/>
                        {amountOfParticipantsAvailableInBoat != null &&
                            <p>
                                {amountOfParticipantsAvailableInBoat < 0 ?
                                    <span style={{color: "red"}}>Er is iets misgegaan bij het ophalen van het aantal beschikbare plekken in de boot.</span>
                                    : amountOfParticipantsAvailableInBoat > 0 ?
                                        <span style={{color: "green"}}>Er zijn nog {amountOfParticipantsAvailableInBoat} plek(ken) beschikbaar in deze boot.</span>
                                        :
                                        <span style={{color: "red"}}>Deze boot zit al vol. Er kunnen geen extra deelnemers meer aan deze boot worden toegevoegd.</span>
                                }
                            </p>
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <DialogTrigger disableButtonEnhancement>
                        <Button as={"a"} className={`button`} appearance="secondary">Annuleren</Button>
                    </DialogTrigger>
                    <DialogTrigger>
                        <Button as={"a"} className={`button`} appearance="primary" onClick={handleAddParticipants} disabled={selectedIds.length === 0 || (amountOfParticipantsAvailableInBoat != null && (amountOfParticipantsAvailableInBoat < 1 || maxParticipantsInBoat - amountOfParticipantsAvailableInBoat < selectedIds.length))} style={{gap: 5}}>
                            {text}
                        </Button>
                    </DialogTrigger>
                </DialogActions>
            </DialogSurface>
        </Dialog>

    );
}

export default AddParticipantButton;